export default class Modal {

    constructor(data = null) {

        this.name       = null;
        this.component  = null;
        this.bind       = null;
        this.class      = null;
        this.callback   = null;
        this.padding    = false;
        this.closeButton = false;

        // Se viene passata un'istanza la setto
        if (data) {
            const keys = Object.keys(data);
            
            keys.forEach( (item) => {
                if(this.hasOwnProperty(item)) {
                    this[item] = data[item];
                }
            });
        }
    }

}